import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCPServer } from '@/api/mcpServer'

export interface MCPServerState {
  servers: MCPServer[]
  loading: boolean
  error: string | null
}

const initialState: MCPServerState = {
  servers: [],
  loading: false,
  error: null,
}

const mcpServerSlice = createSlice({
  name: 'mcpServer',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
      state.loading = false
    },
    setServers: (state, action: PayloadAction<MCPServer[]>) => {
      state.servers = action.payload
      state.loading = false
      state.error = null
    },
    addServer: (state, action: PayloadAction<MCPServer>) => {
      state.servers.push(action.payload)
    },
    updateServer: (state, action: PayloadAction<MCPServer>) => {
      const index = state.servers.findIndex((s) => s.id === action.payload.id)
      if (index !== -1) {
        state.servers[index] = action.payload
      }
    },
    removeServer: (state, action: PayloadAction<number>) => {
      state.servers = state.servers.filter((s) => s.id !== action.payload)
    },
    clearServers: (state) => {
      state.servers = []
      state.error = null
    },
  },
})

export const {
  setLoading,
  setError,
  setServers,
  addServer,
  updateServer,
  removeServer,
  clearServers,
} = mcpServerSlice.actions

export default mcpServerSlice.reducer

